import { Controller } from "@hotwired/stimulus"

const CENTER_IN_SCROLL_CONTAINER = { block: "center" }

export default class extends Controller {
  connect() {
    this.scrollIntoCenterView()
  }

  scrollIntoCenterView() {
    this.element.scrollIntoView(CENTER_IN_SCROLL_CONTAINER)
  }
}
